import BillingProduct from '@/datatypes/billing/product';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class BillingProviderProduct {
  public id: string;
  public name: string;
  public active: boolean;
  public billingProduct = new BillingProduct({});
  public createdAt: string;

  constructor(options) {
    this.id = options.id;
    this.name = options.name;
    this.active = options.active;
    if (options.billingProduct) {
      this.billingProduct = new BillingProduct(camelcaseKeysDeep(options.billingProduct));
    }
    this.createdAt = options.createdAt;
  }
}
